var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-information-index"},[_c('PageTitle',{attrs:{"titleText":"お知らせ"}}),_c('router-link',{attrs:{"to":{
      name: 'admin-information',
      params: { mc_code: _vm.currentUser.mansion._id },
    }}},[(_vm.isPermission('Admin'))?_c('ButtonAdmin',{attrs:{"text":"→お知らせ登録はこちら","width":"18rem"}}):_vm._e()],1),_c('News')],1)}
var staticRenderFns = []

export { render, staticRenderFns }